let elementCache;

/**
 * Handle interactions with a language selector
 *
 * @param {Event} event the event object
 */
function handleEvents(event) {
  if (event.target.matches('.plarium-language-selector__button')) {
    event.preventDefault();
    event.target.parentElement.classList.toggle('is-open');
    return;
  }

  if (!event.target.closest('.plarium-language-selector')) {
    elementCache.forEach((el) => {
      el.classList.remove('is-open');
    });
  }
}

/**
 * Setup actions for interactions with language selectors
 */
function setupLanguageSelectors() {
  elementCache = Array.from(document.querySelectorAll('.plarium-language-selector'));

  if (!elementCache.length) {
    return;
  }

  document.addEventListener('click', handleEvents);
}

window.addEventListener('DOMContentLoaded', setupLanguageSelectors);
